import { SwiperItem } from '../../../libs/gin-tonic/components/swiper';
import { Component } from '../../../libs/gin-tonic/helpers/compiler';

@Component({ className: 'js-lists' })
export class ListsComponent {
	constructor(private element: HTMLElement) {
		const vw = window.innerWidth;
		const count = this.element.getAttribute('data-list-item-count');
		const maxSlidesPerView = parseInt(count || "");
		const wrapperWidth = vw / 12 * (maxSlidesPerView >= 4 ? 10 : 8);

		new SwiperItem(this.element, {
			vertical: false,
			spacing: 20,
			autoplay: 3000,
			mousewheelTarget: '.c-lists',
			breakpoints: {
				0: {
					slidesPerView: 1,
					width: (vw - 40),
				},
				992: {
					slidesPerView: Math.min(2, maxSlidesPerView),
					spaceBetween: vw / 12 * 2,
					width: maxSlidesPerView >= 4 ? (wrapperWidth - (vw / 12 * 2)) : wrapperWidth
				},
				1400: {
					slidesPerView: Math.min(3, maxSlidesPerView),
					spaceBetween: vw / 12 * 1.3,
					width: wrapperWidth
				},
				1600: {
					slidesPerView: Math.min(4, maxSlidesPerView),
					spaceBetween: vw / 12 * (Math.min(4, maxSlidesPerView) == 4 ? 1 : 1.3),
					width: wrapperWidth
				}
			},
		});
	}
}
